var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "320px",
    height: "320px",
    viewBox: "0 0 320 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.054345,194.463681 C171.673895,212.821227 166.127016,222 164.413708,222 C161.516,222 143.068213,179.575039 143.068213,179.575039 C140.002562,167.440953 144.510138,164 144.510138,164 C164.413708,181.079574 184,164 184,164 L184,168.888627 C184,187.000367 181.054345,194.463681 181.054345,194.463681 Z M236.139857,206.245633 L235.04453,198.567739 C234.680336,193.997865 231.394904,191.255721 231.394904,191.255721 L219.896166,185.954095 L195.838518,174.984967 C189.849924,172.609249 185.035208,164.01694 185.035208,164.01694 L183.758059,164.01694 L184.671015,155.789957 C185.900148,154.646739 193.404781,142.934604 193.404781,126.739257 C193.404781,118.965643 194.708584,85 163.863094,85 C133.017604,85 134.809486,115.762442 134.809486,126.739257 C134.809486,134.057134 137.704724,143.740701 143.495201,155.789957 L143.495201,164.01694 C142.400423,166.759085 133.017604,172.974025 133.017604,172.974025 C124.074263,174.071103 105.092804,184.673254 105.092804,184.673254 C89.5791474,184.857017 89.0309345,193.631989 89.0309345,193.631989 C87.7537852,196.922122 88.1185281,203.868814 88.1185281,203.868814 C83.3730258,212.095797 83.5553972,213.923527 83.5553972,213.923527 C83.5553972,220.139017 81,225.622756 81,225.622756 C107.070866,232.540919 134.691897,236 163.863094,236 C195.218758,236 219.919283,232.540919 237.96467,225.622756 L238.513432,224.892104 C239.60821,222.14996 238.513432,215.568593 238.513432,215.568593 C236.322778,213.010212 236.139857,206.245633 236.139857,206.245633 Z",
    id: "Fill-29",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard);
export default __webpack_public_path__ + "static/media/Artboard.62ca88f15e216f1febea20d2943243de.svg";
export { ForwardRef as ReactComponent };